
export const navbarLinks = [
    {
        path: "/portfolio",
        name:"Portfolio"
    },
    {
        path: "/about",
        name:"Biz haqimizda"
    },
    {
        path: "/school",
        name:"Tasnif maktab"
    },
    {
        path: "/connection",
        name:"Aloqa"
    }
]